import { SC } from "../helper/ServerCall"

export const customMusicServices = {
    getCustomMusic
}

function getCustomMusic() {
    return SC.getCall('customMusic');
}